import type { TenantConfig } from '@/types/TenantConfig'

const lightGrey = '#E9EFF2'
const slate = '#425865'
const orange = '#FD9333'

export const pasadenashowcase: TenantConfig = {
  logo: 'assets/pasadenashowcase/static/logo.png',
  themeOptions: {
    logoHeight: '65px',
    pageBackgroundColor: lightGrey,
    headerDropShadow: '0 0 10px 0 rgba(0, 0, 0, 0.3)',
    footerBackgroundColor: slate,
    footerTextColor: 'white',
    cartHeaderBackgroundColor: slate,
    primaryColor: slate,
    secondaryColor: orange,
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/pasadenashowcase/static/completed.jpeg',
      },
      completedContentOffset: {
        desktop: '-300px',
        mobile: '-150px',
      },
    },
  },
  i18nOverrides: {
    en: {
      membershipRoute: {
        unavailableMessage:
          'Pasadena Showcase House for the Arts is an all-volunteer organization. With the hard work and dedication of its 200+ members, the organization raises funds from its major benefit, the Pasadena Showcase House of Design—one of the oldest, largest, and most successful home and garden tours in the country. In addition to producing the Showcase House, members volunteer their time toward the organization\'s four philanthropic initiatives: the Music Mobile, Instrumental Competition, Youth Concert, and Gifts & Grants. Applications for membership are accepted throughout the year. <a href="https://pasadenashowcase.org/membership/">Learn more about becoming a member</a>.',
      },
    },
  },
}
